import Button from '@eduzz/houston-ui/Button';
import Modal from '@eduzz/houston-ui/Modal';
import * as React from 'react';

type FidcAlertModalProps = {
  isOpen: boolean;
  onClose: () => void;
};

export function FidcAlertModal({ isOpen, onClose }: FidcAlertModalProps) {
  return (
    <Modal visible={isOpen} onClose={onClose} closeIcon={false}>
      <Modal.Header>Atenção!</Modal.Header>
      <Modal.Content>
        E aí, tudo bem? Nós da Eduzz esperamos que sim!
        <br />
        <br />
        Temos novidades na área!
        <br />
        <br />
        Como você sabe, nós da Eduzz sempre buscamos o melhor jeito de poder fazer com que sua experiência seja sempre única - e dessa vez não seria
        diferente!
        <br />
        <br />
        Notamos que há algumas coisas que podem fazer com que essa parceria entre nós seja ainda melhor. Pensando nisso, em seus comprovantes, você
        notará o nome <strong>GALAXY FUNDO DE INVESTIMENTO EM DIREITOS CREDITÓRIOS PADRONIZADOS</strong> - e não mais Eduzz. Por isso, não se assuste!
        <br />
        <br />
        A experiência em nossa plataforma, agora, vai além de um acesso - supera galáxias!
        <br />
        <br />
        Combinado?
      </Modal.Content>
      <Modal.Footer>
        <Button onClick={onClose}>Entendi</Button>
      </Modal.Footer>
    </Modal>
  );
}
